import { render, staticRenderFns } from "./MiddleBar.vue?vue&type=template&id=754b7f52"
import script from "./MiddleBar.vue?vue&type=script&lang=js"
export * from "./MiddleBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports